import * as types from 'src/store/mutation-types'
import { LocalStorage } from 'quasar'

export default ({ app, router, store, Vue }) => {
  window.addEventListener('storage', event => {
    if (event.key !== 'token') return true
    // If the new value is false, force logout
    if (!event.newValue) {
      store.dispatch('logout')
      router.push('/login')
      return true
    }

    const storageToken = LocalStorage.get.item('token')

    // If the token change, we will update it in the vuex store and check if it's valid
    if (storageToken !== store.getters.token) {
      store.commit(types.SET_TOKEN, storageToken)
      store.dispatch('check')
    }

    // If we did not have a token before and we're currently on the login route, we'll redirect to the / route
    if (!event.oldValue && router.currentRoute.path === '/login') {
      router.replace('/')
    }
  })
}
